/* eslint-disable camelcase */
import logUtil from 'utils/log'
import React from 'react'
import rangeArrayUtil from 'utils/array/range'
import scrollToDivByIdDomUtil from 'containers/QuickShopProductSidebar/components/Reviews/utils/scroll-to-div-by-id'
import ProductCardLikeAndSuperLike from 'components/ProductCard/components/LikeAndSuperLike'

import { isSmallScreenUtil } from 'utils/device'

import shouldLoadLikesAndSuperLikesUtil from 'components/ProductCard/components/Rating/utils/should-load-like-and-super-like/index.js'
import shouldReduceStarsAndTrimTextUtil from 'components/ProductCard/components/Rating/utils/should-reduce-stars-and-trim-text/index.js'
import shouldReduceStarsAndTextBasedOnLikesUtil from 'components/ProductCard/components/Rating/utils/should-reduce-stars-based-on-likes/index.js'
import shouldReduceStarsAndTextBasedOnScreenSizeUtil from 'components/ProductCard/components/Rating/utils/should-reduce-stars-based-on-screen-size/index.js'
import shouldRenderLikesAndSuperLikesUtil from 'components/ProductCard/components/Rating/utils/should-render-likes-and-super-likes/index.js'

const STARS_COUNT = 5

/**
 * @param props
 * @param props.rating
 * @param props.ratingCount
 * @param likedCount
 * @param superLikedCount
 * @param isQuickShop
 * @param isRelatedProduct
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProductCardRating (props) {
  const {
    rating,
    ratingCount,
    likedCount,
    superLikedCount,
    isQuickShop = false,
    isRelatedProduct = false,
    isFromProductPage = false
  } = (props || {})
  let ratingStr
  let ratingInt
  let decimalsStr
  let decimals

  if (rating) {
    ratingStr = rating.toFixed(2)
    ratingInt = parseInt(rating, 10)
    decimalsStr = ratingStr.split('.')[1]
    decimals = parseFloat(decimalsStr)
  }

  const handleClick = () => {
    scrollToDivByIdDomUtil('quick-shop-reviews', 'up')
  }

  const debugProps = {
    rating,
    ratingInt,
    ratingStr,
    ratingCount,
    decimalsStr
  }

  logUtil('ProductCardRating').debug('debugProps=', debugProps)

  const isSmallScreen = isSmallScreenUtil()

  const loadLikesAndSuperLikes = shouldLoadLikesAndSuperLikesUtil(likedCount, superLikedCount)

  const renderLikesAndSuperLikes = shouldRenderLikesAndSuperLikesUtil(likedCount, superLikedCount)

  const reduceStarsAndTrimTextBasedOnLikesAndSuperLikes = shouldReduceStarsAndTextBasedOnLikesUtil(ratingCount, likedCount, superLikedCount, isFromProductPage)

  const reduceStarsAndTrimTextBasedOnScreenSize = shouldReduceStarsAndTextBasedOnScreenSizeUtil(isSmallScreen, isRelatedProduct, renderLikesAndSuperLikes)

  const shouldReduceStarsAndTrimText = shouldReduceStarsAndTrimTextUtil(reduceStarsAndTrimTextBasedOnLikesAndSuperLikes, reduceStarsAndTrimTextBasedOnScreenSize, isQuickShop)

  return (
    <div
      onClick={handleClick}
      className='product-judgme-and-likes flex-row-align-center'
      style={{
        display: 'flex'
      }}
    >
      {
        !!rating && (
          <div className='product-judgme'>
            <div
              className='jdgm-widget jdgm-preview-badge jdgm-preview-badge--with-link jdgm--done-setup'
              data-id='7106685075622'
              data-template='index'
              data-auto-install='false'
            >
              <div
                style={{
                  display: 'flex !important',
                  alignItems: 'center',
                  lineHeight: 'initial'
                }}
                className='jdgm-prev-badge'
                data-average-rating={rating}
                data-number-of-reviews={ratingCount}
                data-number-of-questions='0'
              >
                <span
                  className='jdgm-prev-badge__stars'
                  data-score={rating}
                  tabIndex='0'
                  aria-label={`${rating} stars`}
                  role='button'
                >
                  {shouldReduceStarsAndTrimText
                    ? (
                      <span
                        className={`jdgm-star jdgm--${rating >= 1 ? 'on' : 'off'}`}
                      />
                      )
                    : (
                        rangeArrayUtil(0, STARS_COUNT).map(index => {
                          let classNameSuffix
                          const isLastStar = index === ratingInt
                          if (isLastStar && decimals > 25 && decimals < 75) {
                            classNameSuffix = 'half'
                          } else if (index < rating) {
                            classNameSuffix = 'on'
                          } else {
                            classNameSuffix = 'off'
                          }
                          return (
                            <span
                              key={index}
                              className={`jdgm-star jdgm--${classNameSuffix}`}
                            />
                          )
                        })
                      )}
                </span>

                <span className='jdgm-prev-badge__text'>
                  {shouldReduceStarsAndTrimText ? ratingCount : `${ratingCount} review${ratingCount > 1 ? 's' : ''}`}
                </span>
              </div>
            </div>
          </div>
        )
      }

      {/* Quickshop already has its own component for rendering
      likes and super likes, so we don't use any of these */}

      {!isQuickShop && renderLikesAndSuperLikes && (
        <ProductCardLikeAndSuperLike
          likedCount={likedCount}
          superLikedCount={superLikedCount}
        />
      )}

      {!isQuickShop && loadLikesAndSuperLikes && (
        <div className='product-like' />
      )}
    </div>

  )
}
